/**
 * Created by Jerker Nord on 2019-09-09.
 */
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TweenLite} from "gsap";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class BonusBunniesReelController extends SpinReelController {

    constructor(reelId:number) {
        super(reelId);
    }

    protected createReelView():PIXI.Container {
        const reelView:PIXI.Container = GameModuleConfig.instance.REEL_VIEW ? GameModuleConfig.instance.REEL_VIEW(this._reelId) : new PIXI.Sprite();
        if(this._reelId == 4 || this._reelId == 9 || this._reelId == 14 || this._reelId == 19) {
            reelView.visible = false;
        }
        return reelView;
    }

    protected addNewSymbol(symName:string, state?:ISymbolStateConfig):StateReelSymbol {
        if(this._gameMode == BonusBunniesGameMode.BONUS_GAME) {
            if(symName == "B") {
                symName = "V";
            }
            if("VXB2B3B4B5".indexOf(symName) < 0) {
                symName = "X";
            }
        }
        if(this._gameMode == BonusBunniesGameMode.NORMAL && symName == "X") {
            symName = "L" + (MathHelper.randomIntInRange(1, 5));
        }
        return super.addNewSymbol(symName, state);
    }

    public setStopDelay(delay:number):void {
        if(this._reelStopDelayTimer && this._reelStopDelayTimer.isActive()) {
            this._reelStopDelayTimer.pause();
            this._reelStopDelayTimer.kill();
        }
        this._reelStopDelayTimer = null;
        this._addedStopDelay = 0;
        this._reelStopDelayTimer = TweenLite.to(this, delay, {onComplete : () => this.onStopDelayDone()});
    }

    public resetStopDelay():void {
        this._addedStopDelay = 0;
        this.clearStopDelay();
        this._reelPartAnimator.resetStartSpin(GameSetting.isFastSpin);
    }

    /*
    protected clearStopDelay(quickStop:boolean = false):void {
        // if some other feature required to delay the stop while the normal delay, delay it again.
        if(!quickStop && this._addedStopDelay > 0) {
            this._reelStopDelayTimer = TweenLite.to(this, this._addedStopDelay, {onComplete : () => this.clearStopDelay()});
            this._addedStopDelay = 0;
            return;
        }

        if(this._reelStopDelayTimer && this._reelStopDelayTimer.isActive()) {
            this._reelStopDelayTimer.pause();
            this._reelStopDelayTimer.kill();
        }
        this._reelStopDelayTimer = null;
        this._addedStopDelay = 0;
        this.onStopDelayDone();
    }

     */
}